"use client";

import { DescriptionTabProps } from './types';
export const DescriptionTab = ({ description }: DescriptionTabProps) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-black">Description</h3>
      <div 
        className="text-gray-700 leading-relaxed"
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </div>
  );
}; 